package com.sddamico.swigmore.models

import kotlinx.serialization.Serializable

/** What the league receives for a week. Times are epoch milliseconds. */
@Serializable
data class NotifyPreviewResponse(
  val season: Int,
  val week: Int,
  val published: Boolean,
  /** The announcement already went out, so the copy can no longer change. */
  val announced: Boolean,
  val announceAt: Long,
  val recipients: Int,
  val from: String,
  val headline: String,
  val intro: String,
  val draftedHeadline: String,
  val draftedIntro: String,
  val draftedByClaude: Boolean,
  /** The server has a Claude API key, so the commissioner can ask for a rewrite. */
  val claudeEnabled: Boolean,
  val subject: String,
  val emailHtml: String,
  val pushTitle: String,
  val pushBody: String,
  /** The nudges to owners who haven't voted, in the order they go out. */
  val reminders: List<ReminderPreview>,
  val pushConfigured: Boolean,
)

@Serializable
data class ReminderPreview(val at: Long, val title: String, val body: String)

/** A null or blank field goes back to the drafted text. */
@Serializable
data class CopyEditRequest(val season: Int, val week: Int, val headline: String? = null, val intro: String? = null)
